import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '@/store'

import AllUserResults from '../pages/AllUserResults.vue'
import ClassResults from '../pages/ClassResults.vue'
import Login from '../pages/Login'
import Profile from '../pages/Profile.vue'
import SignUp from '../pages/SignUp.vue'
import Classes from '../pages/Classes.vue'
import Class from '../pages/Class.vue'
import Chapter from '../pages/Chapter.vue'
import GeneralStats from '../pages/GeneralStats.vue'
import Stats from '../pages/Stats.vue'
import Cheats from '../pages/Cheats.vue'
import Leaderboard from '../pages/Leaderboard.vue'
import Test from '../pages/Test.vue'
import Main from '../pages/Main.vue'
import Admin from '../pages/Admin.vue'
import ConfirmMail from '../pages/ConfirmMail.vue'
import ResetPassword from '../pages/ResetPassword.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path: '*',
      redirect: '/'
    },

    {
      path: '/',
      name: 'main',
      component: Main
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },

    {
      path: '/signup',
      name: 'signup',
      component: SignUp
    },

    {
      path: '/confirm_mail/:code',
      name: 'confirmMail',
      component: ConfirmMail
    },

    {
      path: '/reset_password/:code',
      name: 'resetPassword',
      component: ResetPassword
    },

    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },

    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },

    {
      path: '/classes',
      name: 'classes',
      component: Classes
    },

    {
      path: '/classes/:class',
      name: 'class',
      component: Class
    },

    {
      path: '/chapters/:chapter',
      name: 'chapter',
      component: Chapter
    },

    {
      path: '/tests/:test',
      name: 'test',
      component: Test
    },

    {
      path: '/leaderboard/:leaderboard',
      name: 'leaderboard',
      component: Leaderboard
    },

    {
      path: '/all-user-results',
      name: 'all-user-results',
      component: AllUserResults
    },

    {
      path: '/class-results/:class',
      name: 'class-results',
      component: ClassResults
    },

    {
      path: '/general_stats',
      name: 'generalStats',
      component: GeneralStats
    },

    {
      path: '/stats',
      name: 'stats',
      component: Stats
    },

    {
      path: '/cheats',
      name: 'cheats',
      component: Cheats
    }
  ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'login'
    && to.name !== 'signup'
    && to.name !== 'confirmMail'
    && to.name !== 'resetPassword'
    && to.name !== 'main'
    && !Store.getters['auth/authenticated']) {
    return next({
      name: 'main'
    })
  }

  if (to.name === 'admin' && !Store.getters['auth/user'].admin) {
    return next({
      name: 'main'
    })
  }

  if (to.name === 'class-results' && !Store.getters['auth/user'].admin) {
    return next({
      name: 'main'
    })
  }

  if (to.name === 'all-user-results' && !Store.getters['auth/user'].admin) {
    return next({
      name: 'main'
    })
  }

  if (to.name === 'leaderboard' && !Store.getters['auth/user'].admin) {
    return next({
      name: 'main'
    })
  }

  if ((to.name === 'login' || to.name ==='signup') && Store.getters['auth/authenticated']) {
    return next({
      name: 'main'
    })
  }

  next()
})

export default router
